import { render, staticRenderFns } from "./TicketRealtimeNotification.vue?vue&type=template&id=7af0c443&scoped=true"
import script from "./TicketRealtimeNotification.vue?vue&type=script&lang=js"
export * from "./TicketRealtimeNotification.vue?vue&type=script&lang=js"
import style0 from "./TicketRealtimeNotification.vue?vue&type=style&index=0&id=7af0c443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af0c443",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
